import React from "react";
import PropTypes from "prop-types";

import styles from "./CustomTagBarcodesPrintLayout.module.css";
import { generateBarcodeSeries } from "../../../utils/generalBarcodes";
import TagBarcode from "../components/TagBarcode";
import QRCode from "qrcode.react";

const CustomTagBarcodesPrintLayout = ({
  labels,
  series,
  itemsInPage,
  className,
  smallBarcode,
  barcodeStyle,
  pageBreakStyles,
  fullHeight,
  onlyQR,
  minimized,
  pageStyle
}) => {
  const barcodes = generateBarcodeSeries(
    labels,
    series.firstBarcode,
    series.lastBarcode
  );
  const itemsInPageRange = [...Array(itemsInPage).keys()];

  return (
    <div className={`${styles.block} ${className} block`}>
      <style>{`${pageStyle} html,body {margin: 0px;}`}</style>
      <div className={`${styles.page} page`}>
        {Array.from(Array(barcodes.length).keys())
          .filter(i => i % itemsInPage === 0)
          .map(pageOffset => (
            <>
              <div
                key={`page_${pageOffset}`}
                className={`${pageBreakStyles || styles.pageBreak} pageBreak`}
              >
                {itemsInPageRange.map(itemOffset => {
                  const i = pageOffset + itemOffset;
                  const barcode = barcodes[i];
                  return (
                    i < barcodes.length &&
                    (smallBarcode || onlyQR ? (
                      <div
                        key={`bc_${i}`}
                        className={`${styles.barcodeHolder} barcodeHolder`}
                      >
                        <div
                          key={`bc_${i}`}
                          className={`${styles.barcodeDataHolder} barcodeDataHolder`}
                        >
                          <QRCode
                            renderAs="svg"
                            className={`${barcodeStyle ||
                              styles.barcode} barcode`}
                            value={barcode.numberPart}
                          />
                          {onlyQR || (
                            <div className={`${styles.textHolder} textHolder`}>
                              <div className={`${styles.text} text`}>
                                {barcode.numberPart}
                              </div>
                              <div className={`${styles.text} text`}>
                                {barcode.dateLabel}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <TagBarcode
                        barcode={barcode}
                        minimized={minimized}
                        fullHeight={fullHeight}
                      />
                    ))
                  );
                })}
              </div>
              <p style={{ pageBreakBefore: "always" }} />
            </>
          ))}
      </div>
    </div>
  );
};

CustomTagBarcodesPrintLayout.propTypes = {
  className: PropTypes.string,
  itemsInPage: PropTypes.number,
  labels: PropTypes.object,
  pageStyle: PropTypes.any,
  barcodeStyle: PropTypes.any,
  pageBreakStyles: PropTypes.any,
  smallBarcode: PropTypes.any,
  series: PropTypes.object,
  fullHeight: PropTypes.bool,
  minimized: PropTypes.bool,
  onlyQR: PropTypes.bool
};

export default CustomTagBarcodesPrintLayout;
